import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import CategoryNews from "@/pages/category/news/page";
import CategoryRecommend from "@/pages/category/recommend/page";
import NewsDetail from "@/pages/detail/news/page";
import MovieDetail from "@/pages/detail/movie/page";
import SearchPage from "@/pages/search/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/news", element: <CategoryNews /> },
      { path: "category/recommend", element: <CategoryRecommend /> },
      { path: "detail/news/:id", element: <NewsDetail /> },
      { path: "detail/movie/:id", element: <MovieDetail /> },
      { path: "search", element: <SearchPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;